<span *ngIf="loadingStatus || !questionListStatus; else appStatus" class="loading-container" [ngClass]="{'advanced-deal': advancedDeal}">
  <mat-spinner diameter="24" class="loading-app-status"></mat-spinner>
  <div class="loading-text">Loading Application Status...</div>
</span>

<ng-template #appStatus>
  <div id="application-status-display-wrapper" [ngClass]="{'advanced-deal': advancedDeal}">
      <div class="row application-wrapper" [ngClass]="{'advanced-deal': advancedDeal}">
        @if (advancedDeal) {
          <div class="tw-w-full tw-flex tw-justify-between">
            <div class="tw-text-lg tw-font-semibold">Application</div>
            <button 
              class="edit-app-button"
              data-cy="open-question-dialog-link"
              [disabled]="!questionListStatus"
              (click)="openQuestionDialog()">
                Edit App
            </button>
          </div>
        } @else {
          <h2 class="column mb-0">
            Application
          </h2>
          <div class="column tw-text-right">
              <button
                mat-button
                color="primary"
                *ngIf="showEditLink"
                data-cy="open-question-dialog-link"
                [ngStyle]="{cursor:'pointer'}"
                (click)="openQuestionDialog()"
                [disabled]="!questionListStatus">
                Edit App
              </button>
          </div>
      }
      </div>
      <div class="row">
          <div id="percentage-complete" class="column">
              <div data-cy="question-percentage-complete">
                  {{ percentComplete }}% Complete
              </div>
          </div>
          <div class="column">
              <div id="questions-answered" *ngIf="questionListStatus">
                  {{ questionListStatus.fulfilledCount }}/{{ questionListStatus.requiredCount }} Answered
              </div>
          </div>
      </div>
  </div>
</ng-template>
